/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import { CannedCollectionModule } from '@coursera-web/cds-labs';
import type { CannedCollectionModuleCard, CardSize, ColorChoice } from '@coursera-web/cds-labs';

import { useTracker } from '@coursera/event-pulse/react';

import { isExternalLink } from 'bundles/common/utils/urlUtils';
import Container from 'bundles/premium-hub/components/shared/Container';

export type PromoUnitsModuleProps = {
  heading?: string;
  subheading?: string;
  size: CardSize;
  color: ColorChoice;
  backgroundColor?: string;
  showAllEntries?: boolean;
  showImageInFull?: boolean;
  cards: CannedCollectionModuleCard[];
};

const styles = {
  moduleContainer: css`
    margin-top: calc(var(--cds-spacing-100) * 5);
    margin-bottom: calc(var(--cds-spacing-100) * 5);
  `,
};

const PromoUnitsModule = ({
  heading,
  subheading,
  size,
  color,
  backgroundColor,
  showAllEntries,
  showImageInFull,
  cards,
}: PromoUnitsModuleProps) => {
  const trackV3 = useTracker();

  if (!cards.length) {
    return null;
  }

  const cardsWithTracking = cards.map((card, idx) => ({
    ...card,
    onClick: () =>
      trackV3('click_merchandising_module', {
        merchandisingModule: {
          moduleType: 'canned_collection_module',
          heading: card.headline,
          linkURL: card.target,
          index: idx,
        },
        button: {
          name: 'promo_cta',
          linkType: card.target && isExternalLink(card.target) ? 'external' : 'internal',
          linkName: card.ctaText,
          linkURL: card.target,
        },
      }),
  }));

  return (
    <Container css={styles.moduleContainer}>
      <CannedCollectionModule
        heading={heading}
        subheading={subheading}
        cards={cardsWithTracking}
        size={size}
        color={color}
        backgroundColor={backgroundColor}
        showAllEntries={showAllEntries}
        showImageInFull={showImageInFull}
        isPageGridContainerAppliedOnPage
      />
    </Container>
  );
};

export default PromoUnitsModule;
